import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@components/ui/card"
import { GatsbyImage } from "gatsby-plugin-image"

const strings = {
  fr: [
    {
      year: "1960",
      id: "1960",
      title: "Création de l'entreprise",
      subtitle: "Albert Fehr, charpentier, crée son entreprise de bâtiment",
      imageKey: "fehr",
    },
    {
      year: "1968",
      id: "1968",
      title: "1ère centrale béton",
      subtitle:
        "Création de la première centrale à béton. Suivront 8 autres centrales, en Alsace – Lorraine",
      imageKey: "centrale",
    },
    {
      year: "1972",
      id: "1972",
      title: "1er site de préfabrication",
      subtitle:
        "Création du 1er site de préfabrication à Bischwiller en Alsace (67)",
      imageKey: "bischwiller",
    },
    {
      year: "1988",
      id: "1988",
      title: "Premiers grands chantiers avec le Précoffré®",
      subtitle:
        "Industrialisation de la préfabrication à Bischwiller et premiers grands chantiers avec le Précoffré® (Mur à Coffrage Intégré) en Alsace.",
    },
    {
      year: "2002",
      id: "2002",
      title: "Industrialisation à Vernou",
      subtitle:
        "Industrialisation de la préfabrication à Vernou-La Celle sur Seine et premiers grands chantiers avec Le Précoffré® (Mur à Coffrage Intégré).",
      imageKey: "vernou",
    },
    {
      year: "2007",
      id: "2007",
      title: "3ème usine de préfabrication",
      subtitle:
        "Construction de la troisième usine de préfabrication à Châteauneuf-sur-Isère, dans la Drôme (26).",
      imageKey: "chateauneuf",
    },
    {
      year: "2008",
      id: "2008",
      title: "Précoffré® Thermique®",
      subtitle:
        "Précoffré® Thermique : le mur à coffrage et isolation intégrés avec les conteneurs et les élingues intégrées au Précoffré®.",
    },
    {
      year: "2011",
      id: "2011",
      title: "4ème usine en Allemagne",
      subtitle: "Intégration d’une 4ème usine basée à Wiesental en Allemagne.",
      imageKey: "wiesental",
    },
    {
      year: "2013",
      id: "2013",
      title: "Précoffré® Intégral",
      subtitle:
        "Le Précoffré® Intégral avec ses 10 solutions brevetées, facilite la pose et la sécurité en optimisant le rendement de 44% sur chantier",
      imageKey: "integral",
    },
    {
      year: "2014",
      id: "2014",
      title: "5ème usine en Allemagne",
      subtitle:
        "Intégration d’une 5ème usine basée à Achern en Allemagne, spécialisée dans la fabrication d’éléments en Béton Fibré Ultra Hautes Performances.",
      imageKey: "achern", // Assuming a loop back to the start of the image keys
    },
    {
      year: "2015",
      id: "2015",
      title: "FClad®",
      subtitle:
        "Lancement du panneau de bardage en Béton Fibré Ultra Hautes Performances FClad®, with Ductal® Inside.",
      imageKey: "fclad", // Assuming a loop back to the start of the image keys
    },
    {
      year: "2016",
      id: "2016",
      title: "Perfectionnement du configurateur commercial 3D FConcrete",
      subtitle: "Amélioration du configurateur 3D pour FConcrete.",
    },
    {
      year: "2018",
      id: "2018",
      title: "Appli FDriver",
      subtitle:
        "Dématérialisation des bulletins de livraison via l'application FDriver.",
    },
    {
      year: "2019",
      id: "2019",
      title: "Commande de BPE en ligne",
      subtitle:
        "Lancement de la commande de Béton Prêt à l'Emploi (BPE) en ligne.",
    },
    {
      year: "2020",
      id: "2020",
      title: "Précoffré® TH Green bas carbone",
      subtitle:
        "Le premier mur préfabriqué très bas carbone, intégrant une isolation biosourcée à base de fibre de bois.",
      imageKey: "th_green_bas_carbone",
    },
    {
      year: "2021",
      id: "2021",
      title: "Bétondrive",
      subtitle: "1er distributeur autonome de béton prêt à l’emploi.",
      imageKey: "beton_drive_detoure",
    },
    {
      year: "2022",
      id: "2022",
      title: "Béton de terre crue",
      subtitle:
        "Composé de sable, de gravillons, de terre et d’eau. Dématérialisation des factures fournisseurs.",
      imageKey: "beton_de_terre_crue",
    },
    {
      year: "2023",
      id: "2023",
      title: "FOBB Fehr Ossature Bois Béton® Woodwall Ductal®",
      subtitle:
        "Façade mixte à ossature bois intégrant l’isolant, associée à une peau mince extérieure en Béton Fibré à Hautes Performances.",
      imageKey: "fobb",
    },
    {
      year: "2024",
      id: "2024",
      title: "Partenariat FEHR x Materrup",
      subtitle:
        "Divisez l'empreinte carbone de vos chantiers par 2 avec le Béton d’argile non calcinée Materrup.",
      imageKey: "materrup",
    },
  ],
  de: [
    {
      year: "1960",
      id: "1960",
      title: "Entstehung des Unternehmens",
      subtitle: "Albert Fehr, Zimmerer, gründet sein eigenes Bauunternehmen",
      imageKey: "fehr",
    },
    {
      year: "1968",
      id: "1968",
      title: "Erstes Betonwerk",
      subtitle:
        "Gründung des ersten Betonwerks. Später folgen acht weitere Werke in Elsass-Lothringen.",
      imageKey: "centrale",
    },
    {
      year: "1972",
      id: "1972",
      title: "Erste Produktionsstätte für Betonfertigteile",
      subtitle:
        "Gründung der ersten Produktionsstätte für Betonfertigteile in Bischwiller im Elsass.",
      imageKey: "bischwiller",
    },
    {
      year: "1988",
      id: "1988",
      title: "Erste Großbaustellen mit der Précoffré® Doppelwand",
      subtitle:
        "Industrialisierung der Vorfertigung in Bischwiller und erste Großbaustellen mit der Précoffré® Doppelwand im Elsass.",
    },
    {
      year: "2002",
      id: "2002",
      title: "Industrialisierung in Vernou",
      subtitle:
        "Industrialisierung der Vorfertigung in Vernou-La Celle sur Sein und erste Großbaustellen mit der Précoffré® Doppelwand.",
      imageKey: "vernou",
    },
    {
      year: "2007",
      id: "2007",
      title: "Dritte Produktionsstätte für Betonfertigteile",
      subtitle:
        "Bau der dritten Produktionsstätte für Betonfertigteile in Châteauneuf-sur-Isère im Departement Drôme.",
      imageKey: "chateauneuf",
    },
    {
      year: "2008",
      id: "2008",
      title: "Précoffré® Thermique (Thermo-Doppelwand)",
      subtitle:
        "Précoffré® Thermique: Doppelwand mit integrierter Wärmedämmung und optimaler Sicherheit mit Containern und Anschlagmitteln, die in Précoffré® integriert sind",
    },
    {
      year: "2011",
      id: "2011",
      title: "Viertes Produktionswerk in Deutschland",
      subtitle: "Eingliederung eines vierten Werks in Wiesental in Deutschland",
      imageKey: "wiesental",
    },
    {
      year: "2013",
      id: "2013",
      title: "Précoffré® Intégral (integrale Doppelwand)",
      subtitle:
        "Précoffré® Intégral mit ihren 10 patentierten Lösungen vereinfacht Einbau und Sicherheit, indem die Arbeitsleistung auf der Baustelle um 44% optimiert wird.",
      imageKey: "integral",
    },
    {
      year: "2014",
      id: "2014",
      title: "Fünftes Produktionswerk in Deutschland",
      subtitle:
        "Eingliederung eines fünften Werks in Achern in Deutschland, das auf die Herstellung von Elementen aus ultrahochfestem Faserbeton spezialisiert ist.",
      imageKey: "achern",
    },
    {
      year: "2015",
      id: "2015",
      title: "FClad®",
      subtitle:
        "Einführung des UHFB-Fassadensystems FClad®, with Ductal® Inside.",
      imageKey: "fclad",
    },
    {
      year: "2016",
      id: "2016",
      title: "Verbesserung des 3D-Konfigurators FConcrete",
      subtitle: "Weiterentwicklung des 3D-Konfigurators für FConcrete.",
    },
    {
      year: "2018",
      id: "2018",
      title: "FDriver App",
      subtitle: "Digitalisierung der Lieferscheine über die FDriver App.",
    },
    {
      year: "2019",
      id: "2019",
      title: "Online-Bestellung von BPE",
      subtitle: "Einführung der Online-Bestellung von Frischbeton (BPE).",
    },
    {
      year: "2020",
      id: "2020",
      title: "Précoffré® TH Green kohlenstoffarm",
      subtitle:
        "Die erste kohlenstoffarme Fertigteilwand mit Holzfaser-Dämmung.",
      imageKey: "th_green_bas_carbone",
    },
    {
      year: "2021",
      id: "2021",
      title: "Bétondrive",
      subtitle: "Erster autonomer Verteiler für Frischbeton.",
      imageKey: "beton_drive_detoure",
    },
    {
      year: "2022",
      id: "2022",
      title: "Lehmbeton",
      subtitle:
        "Bestehend aus Sand, Kies, Lehm und Wasser. Digitalisierung der Lieferantenrechnungen.",
      imageKey: "beton_de_terre_crue",
    },
    {
      year: "2023",
      id: "2023",
      title: "FOBB Fehr Holz-Beton-Verbund® Woodwall Ductal®",
      subtitle:
        "Holz-Beton-Verbundfassade mit integrierter Dämmung und dünner Außenhaut aus Hochleistungsfaserbeton.",
      imageKey: "fobb",
    },
    {
      year: "2024",
      id: "2024",
      title: "Partnerschaft FEHR x Materrup",
      subtitle:
        "Halbierung des CO2-Fußabdrucks auf Baustellen durch ungebrannten Lehm-Beton von Materrup.",
      imageKey: "materrup",
    },
  ],
  en: [
    {
      year: "1960",
      id: "1960",
      title: "Albert Fehr",
      subtitle: "Albert Fehr, carpenter, started his own building firm.",
      imageKey: "fehr",
    },
    {
      year: "1968",
      id: "1968",
      title: "1st concrete mixing plant",
      subtitle:
        "Construction of the first concrete mixing plant. 8 more would follow, in Alsace and Lorraine.",
      imageKey: "centrale",
    },
    {
      year: "1972",
      id: "1972",
      title: "1st precasting plant",
      subtitle:
        "Creation of the 1st precasting plant in Bischwiller in Alsace.",
      imageKey: "bischwiller",
    },
    {
      year: "1988",
      id: "1988",
      title: "First large-scale jobs with the Précoffré® product",
      subtitle:
        "Industrialisation of the precasting process at Bischwiller and first big jobs with the Précoffré® integrated-formwork wall product in Alsace.",
    },
    {
      year: "2002",
      id: "2002",
      title: "Industrial plant opened at Vernou",
      subtitle:
        "Industrialisation of the precasting process at Vernou-La Celle sur Seine and first big jobs with the Précoffré® integrated-formwork wall product.",
      imageKey: "vernou",
    },
    {
      year: "2007",
      id: "2007",
      title: "3rd precasting plant",
      subtitle:
        "Construction of the third precasting plant in Châteauneuf-sur-Isère in the Drôme.",
      imageKey: "chateauneuf",
    },
    {
      year: "2008",
      id: "2008",
      title: "Thermal Précoffré®",
      subtitle:
        "Précoffré® Thermique: the wall with integrated formwork and integrated insulation that guaranteed optimum safety with the containers and slings integrated with the Précoffré® wall.",
    },
    {
      year: "2011",
      id: "2011",
      title: "4th factory, in Germany",
      subtitle: "Integration of a 4th factory in Wiesental in Germany.",
      imageKey: "wiesental",
    },
    {
      year: "2013",
      id: "2013",
      title: "Précoffré® Intégral",
      subtitle:
        "The Précoffré® Intégral product, with its 10 patented solutions, facilitates installation and improves safety while optimising productivity, gaining 44% on the construction site.",
      imageKey: "integral",
    },
    {
      year: "2014",
      id: "2014",
      title: "5th factory, in Germany",
      subtitle:
        "Integration of a 5th factory based in Achern in Germany, specialising in Ultra High Performance Fibre-Reinforced Concrete elements.",
      imageKey: "achern",
    },
    {
      year: "2015",
      id: "2015",
      title: "FClad®",
      subtitle:
        "Launch of the FClad® Ultra High Performance Fibre-Reinforced Concrete cladding panel with Ductal® Inside.",
      imageKey: "fclad",
    },
    {
      year: "2016",
      id: "2016",
      title: "Improvement of the 3D FConcrete configurator",
      subtitle: "Refinement of the 3D configurator for FConcrete.",
    },
    {
      year: "2018",
      id: "2018",
      title: "FDriver App",
      subtitle: "Digitalisation of delivery notes via the FDriver app.",
    },
    {
      year: "2019",
      id: "2019",
      title: "Online BPE ordering",
      subtitle: "Launch of online ordering for Ready-Mix Concrete (BPE).",
    },
    {
      year: "2020",
      id: "2020",
      title: "Précoffré® TH Green low carbon",
      subtitle:
        "The first very low-carbon prefabricated wall, with bio-sourced insulation made from wood fibre.",
      imageKey: "th_green_bas_carbone",
    },
    {
      year: "2021",
      id: "2021",
      title: "Bétondrive",
      subtitle: "First autonomous distributor of ready-mix concrete.",
      imageKey: "beton_drive_detoure",
    },
    {
      year: "2022",
      id: "2022",
      title: "Raw earth concrete",
      subtitle:
        "Made from sand, gravel, earth, and water. Digitalisation of supplier invoices.",
      imageKey: "beton_de_terre_crue",
    },
    {
      year: "2023",
      id: "2023",
      title: "FOBB Fehr Wood-Concrete Structure® Woodwall Ductal®",
      subtitle:
        "Wood-frame façade with integrated insulation and an exterior skin made of Ultra High-Performance Fibre-Reinforced Concrete.",
      imageKey: "fobb",
    },
    {
      year: "2024",
      id: "2024",
      title: "FEHR x Materrup Partnership",
      subtitle:
        "Halve the carbon footprint of your sites with Materrup's uncalcined clay concrete.",
      imageKey: "materrup",
    },
  ],
}

const TimeLine = (props) => {
  const data = useStaticQuery(graphql`
    {
      fehr: file(
        relativePath: { eq: "photo-historique-chantier.jpg" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      centrale: file(
        relativePath: { eq: "photo-historique-centrale.jpg" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      bischwiller: file(
        relativePath: { eq: "site-bischwiller.jpg" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      vernou: file(
        relativePath: { eq: "Site_sitevernou.jpeg" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      chateauneuf: file(
        relativePath: { eq: "Fehr_Site-de-Chateauneuf-sur-Isere.jpeg" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      wiesental: file(
        relativePath: { eq: "Site_FT_deutschland.jpeg" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      integral: file(
        relativePath: { eq: "mur-precoffre-integral.jpg" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      achern: file(
        relativePath: { eq: "Site_Fehr_achern.jpeg" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      fclad: file(
        relativePath: { eq: "fclad_hero_photo.jpg" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      th_green_bas_carbone: file(
        name: { eq: "premur_thermique_3D" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      beton_drive_detoure: file(
        name: { eq: "beton_drive_detoure" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      beton_de_terre_crue: file(
        name: { eq: "beton_de_terre_crue" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      fobb: file(name: { eq: "fobb" }, sourceInstanceName: { eq: "images" }) {
        ...Constrained
      }
      materrup: file(
        name: { eq: "ciment_argile_3_etapes" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
    }
  `)
  return (
    <section className="space-y-3">
      <h2 className="text-6xl">{props.title}</h2>
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-3">
        {strings[props.lang].map((item) => (
          <Card key={item.id}>
            <CardHeader>
              <CardTitle>
                {`${item.year}: ${item.title}`} <hr className="mt-2" />
              </CardTitle>
              <GatsbyImage
                image={data[item.imageKey]?.childImageSharp?.gatsbyImageData}
                alt={item.title}
                className="h-48 rounded-sm"
                objectFit="contain"
              />
              <CardDescription>{item.subtitle}</CardDescription>
            </CardHeader>
          </Card>
        ))}
      </div>
    </section>
  )
}

export default TimeLine
